import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { ChevronLeft } from "lucide-react";

export default function NutritionArticle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [a, setA] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get(`/nutrition/articles/${id}`).then(({ data }) => setA(data)).finally(() => setLoading(false)); }, [id]);

  if (loading) return <AppShell title=""><Skeleton className="h-64 w-full rounded-2xl bg-card" /></AppShell>;
  if (!a) return <AppShell title=""><p className="text-muted-foreground">Article not found.</p></AppShell>;

  return (
    <AppShell title="">
      <button onClick={() => navigate(-1)} className="flex items-center text-muted-foreground text-sm mb-3"><ChevronLeft className="h-4 w-4" /> Back</button>
      <Badge className="bg-[#ccff0c]/15 text-[#ccff0c] border border-[#ccff0c]/20 mb-2">{a.section}</Badge>
      <h1 className="font-display text-3xl font-bold mb-4">{a.title}</h1>
      <div className="prose prose-invert max-w-none">
        {a.body.split("\n\n").map((p, i) => (
          <p key={i} className="text-muted-foreground leading-relaxed mb-4 whitespace-pre-wrap">{p}</p>
        ))}
      </div>
    </AppShell>
  );
}
